export default __webpack_public_path__ + "static/media/banner.c3c87731.jpg";